import React, { useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import MomentUtils from '@date-io/moment';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment, { Moment } from 'moment';
import API from '../../api/index';
import { TransactionsResponse } from '../../models/TransactionsResponse';
import { AuthResponse } from '../../models/api/AuthResponse';
import Spinner from '../../components/Spinner/Spinner';
import Alert from '../../components/Alert/Alert';
import { RootState } from '../../models/RootState';
import {
  logout,
  fetchBettingCurrency,
  getCurrencyTypeFromToken,
} from '../../store';
import './TransactionRequest.scss';
import { Button, MenuItem, Select, Tab, Tabs } from '@material-ui/core';
import SelectSearch from 'react-select-search';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import {
  OfflineTransactionStatusTypeMap,
  OfflineTransactionTypeMap,
} from '../../util/stringUtil';
import {
  IonRow,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonButton,
} from '@ionic/react';
import { useSelector } from 'react-redux';
type options = { name: string; value: string };

const TransactionRequest: React.FC = () => {
  const langData = useSelector((state: RootState) => state.common.langData)
  const [errorMsg, setErrorMsg] = useState(null);
  const [loading, setLoading] = useState<Boolean>(false);
  const [transactionRequest, setTransactionRequest] = useState<
    TransactionsResponse[]
  >([]);
  const [fromDate, setfromDate] = useState<Moment>(moment().subtract(3, 'd'));
  const [toDate, setToDate] = useState<Moment>(moment());
  const [transactionStatus, setTransactionStatus] = useState<number>(-1);
  const [transactionType, setTransactionType] = useState<number>(-1);
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const [currpage, setcurrpage] = useState<number>(1);
  const pageSize = 25;
  const [sectionTabVal, setSectionTabVal] = useState(0);

  const fetchTransactionRequest = useCallback(async () => {
    setLoading(true);
    setErrorMsg(null);

    try {
      const response: AuthResponse = await API.get(
        '/offline-transaction/user-transaction',
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          params: {
            startDate: fromDate.startOf('day').toISOString(),
            endDate: toDate.endOf('day').toISOString(),
            nRec: pageSize,
            pageNum: currpage,
            transactionStatus: transactionStatus,
            transactionType: transactionType,
          },
        }
      );
      if (response.status === 200) {
        const items = response.data;
        for (const item of items) {
          item.amount = item.amount / cFactor;
        }
        setTransactionRequest(items);
        setLoading(false);
      } else {
        setLoading(false);
        throw new Error(response.data);
      }
    } catch (err) {
      if (err.response && err.response.data) {
        setErrorMsg(err.response.data.error);
      }
      setLoading(false);
    }
  }, [fromDate, toDate, transactionStatus, transactionType]);

  useEffect(() => {
    if (currpage !== 1) setcurrpage(1);
    else fetchTransactionRequest();
  }, [fromDate, toDate, transactionStatus, transactionType]);

  const fromDateChangeHandler = (d: Moment) => {
    setfromDate(d);
  };

  const toDateChangeHandler = (d: Moment) => {
    setToDate(d);
  };

  const nextpageHandler = () => {
    setLoading(true);
    setcurrpage(currpage + 1);
  };

  const prevpageHandler = () => {
    setLoading(true);
    setcurrpage(currpage - 1);
  };

  const viewImage = (data) => {
    const base64ImageData = data;
    const contentType = data.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];

    const byteCharacters = atob(
      base64ImageData.substr(`data:${contentType};base64,`.length)
    );
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl, '_blank');
  };

  return (
    <div className="reports-ctn admin-pl-stmt-ctn">
      <>
        <div className="header-ctn">
          <div className="page-title">{langData?.['my_transactions']}
          </div>
        </div>
        <div className="content-ctn light-bg">
          <div>
            <div className="admin-pl-filters-row filters-row">
              <div className="filter-col">
                <div className="txn-type-select trans-select-filter">
                  <IonLabel className="label">{langData?.['transaction_type']}</IonLabel>
                  <IonSelect
                    value={transactionType}
                    placeholder={langData?.['select_one']}
                    interface="popover"
                    onIonChange={(e) => setTransactionType(e.detail.value)}
                  >
                    <IonSelectOption value={-1}>{'All'}</IonSelectOption>
                    {Object.keys(OfflineTransactionTypeMap).map((opt, idx) => (
                      <IonSelectOption value={OfflineTransactionTypeMap[opt]}>
                        {opt}
                      </IonSelectOption>
                    ))}
                  </IonSelect>
                </div>
                <div className="txn-type-select trans-select-filter">
                  <IonLabel className="label">{langData?.['transaction_status']}</IonLabel>
                  <IonSelect
                    value={transactionStatus}
                    placeholder={langData?.['select_one']}
                    interface="popover"
                    onIonChange={(e) => setTransactionStatus(e.detail.value)}
                  >
                    <IonSelectOption value={-1}>{'All'}</IonSelectOption>
                    {Object.keys(OfflineTransactionStatusTypeMap).map(
                      (opt, idx) => (
                        <IonSelectOption
                          value={OfflineTransactionStatusTypeMap[opt]}
                        >
                          {opt}
                        </IonSelectOption>
                      )
                    )}
                  </IonSelect>
                </div>
                <div className="from-date-filter filter-item">
                  <div className="filter-label">{langData?.['start_date']}</div>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                      className="date-filter date-control"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      disableToolbar
                      variant="inline"
                      format="DD/MM/yyyy"
                      margin="normal"
                      id="from-date"
                      value={fromDate}
                      onChange={(e) => fromDateChangeHandler(e)}
                    />
                  </MuiPickersUtilsProvider>
                </div>

                <div className="to-date-filter filter-item">
                  <div className="filter-label">{langData?.['end_date']}</div>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                      className="date-filter date-control"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      disableToolbar
                      variant="inline"
                      format="DD/MM/yyyy"
                      margin="normal"
                      id="to-date"
                      value={toDate}
                      onChange={(e) => toDateChangeHandler(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
          </div>

          {errorMsg ? <Alert message={errorMsg} /> : ''}

          {loading ? (
            <Spinner />
          ) : (
            <>
              <Tabs
                value={sectionTabVal}
                className="eam-ctn-header-tabs"
                onChange={(_, newValue) => {
                  setSectionTabVal(newValue);
                }}
              >
                <Tab label="Deposit" value={0} />
                <Tab label="Withdraw" value={1} />
              </Tabs>

              <div className="tbl-ctn">
                <TableContainer component={Paper} className="apl-table-ctn">
                  <Table className="apl-table">
                    <TableHead className="apl-table-header">
                      <TableRow>
                        <TableCell>{langData?.['user']}</TableCell>
                        {sectionTabVal === 0 ? (
                          <TableCell>{langData?.['reference_id']}</TableCell>
                        ) : null}
                        <TableCell>{langData?.['transaction_type']}</TableCell>
                        <TableCell>{langData?.['transaction_status']}</TableCell>
                        {/* {sectionTabVal === 0 ? ( */}
                        <TableCell>{langData?.['image']}</TableCell>
                        {/* ) : null} */}
                        <TableCell>{langData?.['amount']}</TableCell>
                      </TableRow>
                    </TableHead>
                    {transactionRequest && transactionRequest.length > 0 ? (
                      <>
                        <TableBody className="apl-table-body">
                          {transactionRequest
                            .filter((trans) =>
                              sectionTabVal === 0
                                ? trans.deposit
                                : !trans.deposit
                            )
                            .map((row, index) => (
                              <>
                                <TableRow className="apl-table-row" key={index}>
                                  <TableCell align="left">
                                    {row.username}
                                  </TableCell>
                                  {sectionTabVal === 0 ? (
                                    <TableCell align="left">
                                      {row.referenceTransaction}
                                    </TableCell>
                                  ) : null}
                                  <TableCell align="left">
                                    {row.transactionsType}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.transactionStatusType}
                                  </TableCell>
                                  {/* {sectionTabVal === 0 ? ( */}
                                  <TableCell align="left">
                                    <div
                                      className="link-btn"
                                      // onClick={() => viewImage(row.imageCode)}
                                      onClick={() => {
                                        if (row.imageCode) {
                                          viewImage(row.imageCode);
                                        }
                                      }}
                                    >
                                      {row.imageCode
                                        ? `View Image`
                                        : `No Image`}
                                    </div>
                                  </TableCell>
                                  {/* ) : null} */}
                                  <TableCell align="left">
                                    {row.amount.toFixed(2)}
                                  </TableCell>
                                </TableRow>
                              </>
                            ))}
                        </TableBody>
                      </>
                    ) : null}
                  </Table>
                </TableContainer>
              </div>
            </>
          )}
          <IonRow>
            {currpage === 1 || loading ? null : (
              <IonButton
                className="bl-btn-prev"
                onClick={(e) => prevpageHandler()}
              >
                {langData?.['prev']}({currpage - 1})
              </IonButton>
            )}
            {transactionRequest.length === pageSize && !loading ? (
              <IonButton
                className="bl-btn-next"
                onClick={(e) => nextpageHandler()}
              >
                {langData?.['next']}({currpage + 1})
              </IonButton>
            ) : null}
          </IonRow>
        </div>
      </>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    bettingCurrency: state.common.bettingCurrency,
    currenciesAllowed: state.common.currenciesAllowed,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    logout: () => dispatch(logout()),
    fetchBettingCurrency: () => dispatch(fetchBettingCurrency()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionRequest);
